import { Box, Typography, Button } from "@mui/joy";
import { TopCards, ManageProject, Analytics, ProjectSummary, CalendarWidget, UpcomingEvents } from "./components";
import { useAuth } from "../../hooks";
import moment from "moment";
import { Plus } from "lucide-react";

export default function Dashboard() {
    const { user } = useAuth();

    return (
        <Box
            p={4}
            width={"100%"}
            display={"flex"}
            flexDirection={"column"}
            overflow={"auto"}
            sx={{
                bgcolor: "background.level1", // standard gray background
                boxSizing: "border-box",
                pb: 6,
            }}
        >
            {/* Super Clean Typography Header */}
            <Box display="flex" justifyContent="space-between" alignItems="flex-end" mb={4}>
                <Box>
                    <Typography level="h2" sx={{ fontWeight: 800, letterSpacing: "-0.5px", mb: 0.5 }}>
                        {greeting}, {user?.FirstName || user?.Email?.split("@")[0] || "there"}!
                    </Typography>
                    <Typography level="body-md" sx={{ color: "text.tertiary", fontWeight: 500 }}>
                        Here is what's happening with your projects today.
                    </Typography>
                </Box>
                <Box display="flex" gap={2} alignItems="center">
                    <Typography level="title-sm" sx={{ color: "text.tertiary" }}>
                        {moment().format("dddd, MMMM Do YYYY")}
                    </Typography>
                </Box>
            </Box>

            <Box display={"flex"} gap={4} width={"100%"} flex={1}>
                {/* Left Content Area */}
                <Box flex={1} display="flex" flexDirection="column" gap={4}>
                    {/* Top Cards block */}
                    <TopCards />

                    {/* Charts inline */}
                    <Box display="flex" gap={4} sx={{ height: 320 }}>
                        <Box flex={1.6}>
                            <Analytics />
                        </Box>
                        <Box flex={1}>
                            <ProjectSummary />
                        </Box>
                    </Box>

                    {/* Projects List block */}
                    <ManageProject />
                </Box>

                {/* Right Sidebar */}
                <Box
                    sx={{
                        width: 340,
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                        flexShrink: 0,
                    }}
                >
                    {/* Calendar Widget */}
                    <CalendarWidget />

                    {/* Upcoming Events list */}
                    <UpcomingEvents />
                </Box>
            </Box>
        </Box>
    );
}

const greeting = (() => {
    const h = moment().hour();
    return h < 5
        ? "Good Night"
        : h < 12
          ? "Good Morning"
          : h < 17
            ? "Good Afternoon"
            : h < 21
              ? "Good Evening"
              : "Good Night";
})();
